import { GetAppOutlined, PersonAddOutlined } from '@material-ui/icons';
import { Alert, AlertTitle } from '@material-ui/lab';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { CustomAlert } from '../../../components/customAlert';
import { CustomButton } from '../../../components/customButton';
import { useQuoteTypeStore } from '../../../hooks/useQuoteTypeStore';
import { QuoteStep } from '../../../utils/constants';
import { DownloadQuoteDialog } from './downloadQuoteDialog';
import { LoanSubType } from '@roc/feature-utils';
import { DownloadableQuotesDialog } from '../../loanPricer/downloadableQuoteDialog';

export const DownloadQuoteAlert = observer(() => {
  const { quoteTypeStore } = useQuoteTypeStore();
  const [showDownloadQuoteDialog, setShowDownloadQuoteDialog] = useState(false);

  const isTerm = [LoanSubType.SINGLE_PROPERTY, LoanSubType.RENTAL_PORTFOLIO].includes(quoteTypeStore.loanSubtype);

  return (
    <>
      <CustomAlert
        severity="success"
        variant="outlined"
        action={
          <CustomButton
            size="medium"
            theme="green"
            startIcon={<GetAppOutlined />}
            testId="edit-borrower"
            onClick={() => setShowDownloadQuoteDialog(true)}
          >
            DOWNLOAD QUOTE
          </CustomButton>
        }
      >
        <AlertTitle>Download Quote</AlertTitle>
        <ul>
          <li>
            Please note that quotes are non-binding and subject to underwriting.
          </li>
        </ul>
      </CustomAlert>

      {isTerm ? (
        <DownloadableQuotesDialog
          store={quoteTypeStore}
          open={showDownloadQuoteDialog}
          rateBuydownOptions={[]}
          onClose={() => setShowDownloadQuoteDialog(false)}
          displayOnlySelected />
      ) : (
        <DownloadQuoteDialog
          store={quoteTypeStore}
          open={showDownloadQuoteDialog}
          onClose={() => setShowDownloadQuoteDialog(false)}
        />
      )}


    </>
  );
});
